export const COOKIE_AGE_GATE = 'AGE_GATE';
export const QUERY_AGE_VERIFIED = 'age_verified';